import ApiService, { errorMessage } from "helpers/ApiHelper";

const ROOT = "/api/v1/promo-banners";

export { errorMessage };

/**
 * The banners for one language, plus which one the site is actually serving.
 *
 * `liveId` is computed by the API from the same filter the public read uses,
 * not worked out here: the answer depends on "now", and the editor's clock is
 * not the one the site was served from.
 */
export const fetchBanners = (lang) => ApiService.request(`${ROOT}?lang=${lang}`, "get");

export const createBanner = (banner) => ApiService.request(ROOT, "post", banner);

export const updateBanner = (id, banner) => ApiService.request(`${ROOT}/${id}`, "patch", banner);

/**
 * Publishing is deliberately separate from saving, the same split the page and
 * post editors use: going live is a decision, and a save that could publish by
 * accident is the one mistake this screen must not allow.
 */
export const setBannerStatus = (id, status) =>
  ApiService.request(`${ROOT}/${id}/status`, "patch", { status });

export const deleteBanner = (id) => ApiService.request(`${ROOT}/${id}`, "delete");
